var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7018 25.1122C19.7169 25.1122 25.4037 19.4906 25.4037 12.5561C25.4037 5.62155 19.7169 0 12.7018 0C5.6868 0 0 5.62155 0 12.5561C0 19.4906 5.6868 25.1122 12.7018 25.1122Z",
    fill: "url(#paint0_linear_107_524)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5966 12.1146L11.6197 8.43013C11.0315 7.99292 10.1898 8.40891 10.1898 9.13901V16.5122C10.1898 17.2423 11.0315 17.6541 11.6197 17.2211L16.5966 13.5366C17.0732 13.1758 17.0732 12.4712 16.5966 12.1146Z",
    fill: "url(#paint1_linear_107_524)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_107_524",
    x1: 8.08992,
    y1: 25.9353,
    x2: 16.7582,
    y2: 0.194465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF927A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F00000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_107_524",
    x1: 13.5719,
    y1: 8.25171,
    x2: 13.5719,
    y2: 17.3977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.57
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play_icon.ff5dac2d701bef6235e50e69ce56660b.svg";
export { ForwardRef as ReactComponent };